import { render, staticRenderFns } from "./fenPeople.vue?vue&type=template&id=0f3d692e&scoped=true&"
import script from "./fenPeople.vue?vue&type=script&lang=js&"
export * from "./fenPeople.vue?vue&type=script&lang=js&"
import style0 from "./fenPeople.vue?vue&type=style&index=0&id=0f3d692e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3d692e",
  null
  
)

export default component.exports